import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Header } from './Header';
import { Dashboard } from './Dashboard';
import Chapter from './UI/course/ListChapter';
import DailyAttendance from './UI/attendance/DailyAttendance';
import AttendanceReport from './UI/attendance/AttendanceReport';
import StudentAttendancereport from './UI/attendance/StudentAttendancereport';
import BranchAdminAttendance from './UI/attendance/BranchAdminAttendance';
import { ListStaffs } from './UI/team_members/ListStaffs';
import { ListStudents } from './UI/team_members/ListStudents';
import { ListBranchAdmins } from './UI/team_members/ListBranchAdmins';
import AddLearningJourney from './UI/learning/AddLearningJourney';
import AddTask from './UI/learning/AddTask';
import ViewStaffTask from './UI/learning/ViewStaffTask';
import ViewBranchAdminTask from './UI/learning/ViewBranchAdminTask';
import ViewStudentTask from './UI/learning/ViewStudentTask';
import Profile from './Profile';
import Login from './Login';
import { AddTeamMembers } from './UI/team_members/AddTeamMembers';
import Module from './UI/course/ListModule';
import AddBatch from './UI/batch/AddBatch';
import ProjectAssignment from './UI/assignment/ProjectAssignment';
import SubmitAssignment from './UI/assignment/SubmitAssignment';
import ProjectStaffReview from './UI/assignment/ProjectStaffReview';
import ViewAssignments from './UI/assignment/ViewAssignments';
import ProjectStudentReview from './UI/assignment/ProjectStudentReview';
import Course from './UI/course/ListCourse';
import AddCourse from './UI/course/AddCourse';
import EditCourse from './UI/course/EditCourse';
import LinkedAssessments from './UI/course/LinkedAssessments';
import AddLead from './UI/lead/AddLead';
import FollowUpLead, { FollowupLead } from './UI/lead/FollowupLead';
import StudentAssessmentEntryForm from './UI/assessment/Assessment';
import SearchLead from './UI/lead/SearchLead';
import ViewLead from './UI/lead/ViewLead';
import GenerateCertificatePage from './UI/certificate/Certificate';
import GeneratedCertificatesList from './UI/certificate/CertificateList';
import { VerifyLogin } from './Verifypage';
import VerificationPage from './VerificationPage';
import ForgotPassword from './ForgotPassword';
import OtpVerification from './OtpVerification';
import ResetPassword from './ResetPassword';
import StudentMarksEdit from './UI/assessment/StudentMarksEdit';
import PendingRequests from './UI/edit_requests/PendingRequests';
import EditHistory from './UI/edit_requests/EditHistory';

const RoleGuard = ({ allowed, children }) => {
  const control = Number(localStorage.getItem('control'));
  return allowed.includes(control) ? children : <Navigate to="/course" />;
};

export const Routepage = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = localStorage.getItem('authToken');
    return !!token;
  });

  const handleLogin = () => {
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsAuthenticated(true);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    setIsAuthenticated(!!token);
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login onLogin={handleLogin} />}
        />
        <Route 
        path='/certificate'
        element={<VerifyLogin />}
        />
        <Route
        path='/certificate/validation'
        element={<VerificationPage />}
        />
        <Route
          path="/forgot-password"
          element={<ForgotPassword />}
        />
        <Route
          path="/verify-otp"
          element={<OtpVerification />}
        />
        <Route
          path="/reset-password"
          element={<ResetPassword />}
        />

        {/* Protected Routes */}
        <Route
          path="/"
          element={isAuthenticated ? <Header /> : <Navigate to="/login" />}
        >
          <Route path="dashboard" element={<Dashboard />} />

          {/* Attendance Routes */}
          <Route path="punch-in" element={<DailyAttendance />} />
          <Route path="staff-attendance" element={<AttendanceReport />} />
          <Route path="student-attendance" element={<StudentAttendancereport />} />
          <Route path="branch-admin-attendance" element={<RoleGuard allowed={[1]}><BranchAdminAttendance /></RoleGuard>} />

          {/* Course Routes */}
          <Route path="chapter" element={<Chapter />} />
          <Route path="module" element={<Module />} />
          <Route path="course" element={<Course />} />
          <Route path="add-course" element={<AddCourse />} />
          <Route path="edit-course" element={<RoleGuard allowed={[1, 4]}><EditCourse /></RoleGuard>} />
          <Route path="linked-assessments" element={<LinkedAssessments />} />

          {/* Learning Routes */}
          <Route path="add-task" element={<AddTask />} />
          <Route path="add-learning-journey" element={<AddLearningJourney />} />
          <Route path="staff-task" element={<ViewStaffTask />} />
          <Route path="branch-admin-task" element={<RoleGuard allowed={[1]}><ViewBranchAdminTask /></RoleGuard>} />
          <Route path="student-learning-journey" element={<ViewStudentTask />} />

          {/* Team Member Routes */}
          <Route path="stafflist" element={<ListStaffs />} />
          <Route path="studentlist" element={<ListStudents />} />
          <Route path="branchadminlist" element={<ListBranchAdmins />} />
          <Route path="add-team-member" element={<AddTeamMembers />} />

          <Route path="batch" element={<AddBatch />} />
          <Route path="assignment" element={<ProjectAssignment />} />
          <Route path="submit-assignment" element={<SubmitAssignment />} />
          <Route path="view-assignment" element={<ViewAssignments />} />
          <Route path="review-assignment" element={<ProjectStaffReview />} />
          <Route path="review-studentassignment" element={<ProjectStudentReview />} />

          <Route path="add-lead" element={<AddLead />} />
          <Route path="followup-lead" element={<FollowUpLead />} />
          <Route path="search-lead" element={<SearchLead />} />
          <Route path="view-lead" element={<ViewLead />} />

          <Route path="assessment" element={<StudentAssessmentEntryForm />} />
          <Route path="edit-marks" element={<StudentMarksEdit />} />
          <Route path="admin/requests" element={<PendingRequests />} />
          <Route path="admin/edit-history" element={<EditHistory />} />

          <Route path="generate-certificate" element={<GenerateCertificatePage />} />
          <Route path="generated-certificate" element={<GeneratedCertificatesList />} />

          {/* Profile Route */}
          <Route path="view-profile" element={<Profile />} />
        </Route>

        {/* Fallback Route */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};